/**
 * Phibian Virtual Workforce — Talk to Phoebe (VW-6, #379).
 *
 * Paths and shapes mirror `apps/api/src/domains/virtual-workforce/routes.ts`
 * and `projection.ts`. Approval decisions are NOT here: they go through the
 * one approval door every agent uses (`agents.decideApproval`).
 */
import { get, post } from './transport.js';
export function startConversation(options) {
    return post('/api/virtual-workforce/sessions', undefined, options);
}
export function say(sessionId, utterance, options) {
    return post(`/api/virtual-workforce/sessions/${encodeURIComponent(sessionId)}/turns`, { utterance }, options);
}
export function endConversation(sessionId, options) {
    return post(`/api/virtual-workforce/sessions/${encodeURIComponent(sessionId)}/end`, undefined, options);
}
export function getCase(caseId, options) {
    return get(`/api/virtual-workforce/cases/${encodeURIComponent(caseId)}`, options);
}
//# sourceMappingURL=virtualWorkforce.js.map